module.exports = __webpack_public_path__ + "static/media/task9Planet3.2c5b3584.png";